import { render, staticRenderFns } from "./CouponGuide.vue?vue&type=template&id=155c2276&scoped=true&"
import script from "./CouponGuide.vue?vue&type=script&lang=js&"
export * from "./CouponGuide.vue?vue&type=script&lang=js&"
import style0 from "./CouponGuide.vue?vue&type=style&index=0&id=155c2276&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c2276",
  null
  
)

export default component.exports